module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginationPublic"
  }, [_c('div', {
    staticClass: "paginationPublicSlide"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next,jumper",
      "page-size": 15,
      "total": _vm.totalToPag,
      "current-page": _vm.paginationCurrentPage
    },
    on: {
      "current-change": _vm.paginCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c867da2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subcomponent/subPaginationCom.vue
// module id = 577
// module chunks = 1